import React, { Component } from "react"


/* Entry Point */
class App extends Component {
    render = () => {
        return (
            <div className="app">
                <img src="/images/setting.png" alt="Setting" />
                <div className="title">Технический перерыв</div>
                <p className="text">Стол временно закрыт для подготовки к следующей игре. Мы скоро откроем ставки. Оставайтесь с нами.</p>
            </div>
        )
    }
}

export default App